<template>
  <div :class="this.inputGroupClass">
    <input :class="this.inputClass" describedby="dob_addon" :placeholder="placeholder" v-model="selectedDateInputValue" />
    <span class="input-group-addon" id="dob_addon">
				<span class="glyphicon glyphicon-calendar"></span>
			</span>
  </div>
</template>

<script>
export default {
  props: [
    'value',
    'placeholder',
    'displayFormat',  // The format to display - uses dd/mm/yyyy, mm/dd/yyyy and yyyy-mm-dd
    'valueFormat', // The format to return as a value - uses dd/mm/yyyy, mm/dd/yyyy and yyyy-mm-dd
    'inputClasses',
    'inputGroupClasses'
  ],
  data: function () {
    return {
      // Take the provided value, and convert it from the provided value format to the required display format
      selectedDateInputValue: moment(this.value, this.momentFormat('value')).format(this.momentFormat('display')),
      // Store the date as an object
      selectedDate: moment(this.value, this.momentFormat('value')),
    }
  },
  computed: {
    inputClass() {
      return 'form-control ' + this.inputClasses;
    },
    inputGroupClass() {
      return 'input-group date ' + this.inputGroupClasses;
    }

  },
  mounted: function () {
    var vm = this
    $(this.$el)
        // init datepicker
        .datepicker({
          format: vm.datePickerFormat('display'),
          autoclose: true,
          assumeNearbyYear: true,
          orientation: "bottom",
          todayBtn: "linked",
          todayHighlight: true,
          weekStart: 1
        })
        .on('changeDate', function (e) {
          console.log('dateChange');
          console.log(e.date);
          vm.updateDate(moment(e.date));
          // vm.selectedDate = moment(e.date).format(vm.displayFormat);
          // vm.displayString = moment(e.date).format('DD/MM/YYYY');
          // vm.valueString = moment(e.date).format('YYYY-MM-DD');
          // vm.$emit('input', moment(e.date).format(vm.valueFormat));

        });
  },
  destroyed: function () {
    $(this.$el).datepicker('hide').datepicker('destroy');
  },
  methods: {
    updateDate(newDate) {
      this.selectedDate = newDate;
      this.selectedDateInputValue = this.selectedDate.format(this.momentFormat('display'));
      this.$emit('input', this.selectedDate.format(this.momentFormat('value')))
    },
    momentFormat(formatStyle) {
      let dateFormatString;
      if (formatStyle == 'value') {
        dateFormatString = this.valueFormat;
      }
      else {
        dateFormatString = this.displayFormat;
      }
      switch (dateFormatString) {
        case 'dd/mm/yyyy':
          return 'DD/MM/YYYY';
          break;
        case 'mm/dd/yyyy':
          return 'MM/DD/YYYY';
          break;
        case 'yyyy-mm-dd':
          return 'YYYY-MM-DD';
          break;
      }
      return 'DD/MM/YYYY';
    },
    datePickerFormat(formatStyle) {
      let dateFormatString;
      if (formatStyle == 'value') {
        dateFormatString = this.valueFormat;
      }
      else {
        dateFormatString = this.displayFormat;
      }
      switch (dateFormatString) {
        case 'dd/mm/yyyy':
          return 'dd/mm/yyyy';
          break;
        case 'mm/dd/yyyy':
          return 'mm/dd/yyyy';
          break;
        case 'yyyy-mm-dd':
          return 'yyyy-mm-dd';
          break;
      }
      return 'dd/mm/yyyy';
    }
  }
}
</script>
